import { Dialog, styled } from "@mui/material";

// const MuiCustomModal = styled(Dialog)(({ theme }) => ({
//     '& .MuiDialogContent-root': {
//         padding: theme.spacing(2),
//     },
//     '& .MuiDialogActions-root': {
//         padding: theme.spacing(1),
//     },
// }));


export const MuiCustomModal = styled(Dialog)(({ theme }) => ({
    '& .MuiDialog-container': {
        overflowY: "auto",
        margin: "auto",
        alignItems: "flex-start",
    },
    '& .MuiPaper-root': {
        maxHeight: "none",
        overflowY: "hidden",
        borderRadius: 20
    },
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
        backgroundColor: "red"
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
        backgroundColor: "red"
    },
}));

export default MuiCustomModal;